export class LiftingEquipment {
  constructor(
    public readonly materieelAmount: string,
    public readonly materieelTonnage: string,
    public readonly materieelType: string,
    public readonly materieelBrand: string,
    public readonly materieelModel: string,
  ) {
  }

  static fromJson(json: any): LiftingEquipment {
    return new LiftingEquipment(
      json["materieelAmount"],
      json["materieelTonnage"],
      json["materieelType"],
      json["materieelBrand"],
      json["materieelModel"],
    )
  }
}
